import { render, staticRenderFns } from "./SendOnboardingLink.vue?vue&type=template&id=191aebaa&scoped=true&"
import script from "./SendOnboardingLink.vue?vue&type=script&lang=js&"
export * from "./SendOnboardingLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191aebaa",
  null
  
)

export default component.exports